import { Component, Inject, OnInit,ViewChild } from '@angular/core';
import { Subscription} from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

import { VersionService } from '../../services/version.service';
import { UserService } from '../../services/user.service';
import { ThemeService } from 'src/app/theme/theme.service';
import * as moment from 'moment';

@Component({
  selector: 'app-versions',
  templateUrl: './versions.component.html',
  styleUrls: ['./versions.component.scss']
})
export class VersionsComponent implements OnInit {

  @ViewChild('nameField') nameField: any;
  user: any;
  private versionsData$: Subscription;
  versionsData:any;

  isLoading = false;

  // sVersionsBind is an array to work with the material list component,
  // sVersionSelected is a single number that gets update to the array value
  // when it is updated
  sVersionBind=[];
  sVersionSelected = "";
  sVersionLatest = "";
  sOrginalName = "";
  sName = "";
  sCreatedBy = "";
  sCreatedOn = "";
  showEditable = false;
  showSave = false;
  showCancel = false;
  showDelete = false;
  showAdd = true;

  get disableSnapshot() {
    return !this.showDelete || this.sVersionLatest != this.sVersionSelected;
  }

  constructor(
    public versionService: VersionService,
    public userService: UserService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<VersionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {

  }

  ngOnInit(): void {

    this.showEditable = this.data["showEditable"];
    this.sVersionBind = [this.data["sVersion"]];
    this.sVersionSelected = this.data["sVersion"];

    // wire up the versions
    this.versionsData$ = this.versionService.versions$.subscribe(
      (responsedata: any) => {
        if(responsedata!=null){
          if(responsedata.loading){
            this.isLoading = true;
          } else {
            this.isLoading = false;
            this.versionsData = responsedata["data"];

            // for an add - version is undefined - pick the top one
            if(this.sVersionSelected==undefined){
              if(this.versionsData.length>0){
                let topone = this.versionsData[0].id
                this.sVersionSelected = topone
              }
            }
            if(this.versionsData.length>0){
              this.sVersionLatest = this.versionsData[0].id
            }

            this.sVersionBind = [this.sVersionSelected]
            this.selectionChange([this.sVersionSelected])
          }
        }
      }
    )

    this.userService.user$.subscribe(data => {
      if (data != null) {
        this.user = data[0];
      }
    })
  }

  selectionChange(event){

    // console.log("----selected:" + event[0])
    if(event[0]==undefined) return;

    this.sVersionSelected = event[0];

    // if this is the initial version - then can't edit it
    if(this.sVersionSelected == "0"){
      this.sName = "Initial";
      this.sCreatedBy = "";
      this.sCreatedOn = "";
      this.showSave = false;
      this.showCancel = false;
      this.showDelete = false;
      this.showAdd = true;

    } else {

      // find the right one
      let vdata = this.versionsData.filter(x => (x["id"] == this.sVersionSelected))
      if(vdata.length>0){
        this.sName = vdata[0].name
        this.sCreatedBy = vdata[0].createdby
        this.sCreatedOn = vdata[0].created
        this.showSave = false;
        this.showCancel = false;
        this.showDelete = true;
      } else {
        // not in list must be after a delete so pick the top one - if there are any
        if(this.versionsData.length>0){
          let topone = this.versionsData[0].id
          this.sVersionBind  = [topone]
          this.selectionChange([topone])
        } else {
          this.sName = "";
          this.sCreatedBy = "";
          this.sCreatedOn = "";
          this.showSave = false;
          this.showCancel = false;
          this.showDelete = false;
        }
      }
  }

  }

  quickAdd():void {
    if(this.sVersionSelected=='0') return;

    let vdata = this.versionsData.filter(x => (x["id"] == this.sVersionSelected));

    let timestamp = moment().utc().format("MMM, D YYYY - HH:mm");
    if(vdata.length > 0) {
      this.sVersionSelected = undefined;

      let udata = this.deepCopy(vdata[0]);
      udata["name"] = `SNAPSHOT @ ${timestamp}`;
      udata["accountid"] = this.data.account["id"];
      udata["action"] = "copylast";
      udata["type"] = "snapshot";
      this.versionService.snapshotVersion(udata);
    }
  }

  save():void {
    if(this.sVersionSelected=='0') return;

    // save the new name
    let data = {};
    let vdata = this.versionsData.filter(x => (x["id"] == this.sVersionSelected))

    if(vdata.length>0){
      // update
      data = this.deepCopy(vdata[0]);
      data["name"] = this.sName;
      this.versionService.updateVersion(data);

    } else {
      // it is an add - ask if they want to copy the last set of data
      const dialogRef = this.dialog.open(YesNoDialog, {
        width: '350px',
        data: {title:"Confirm", text: "Would you like to copy the last version (Yes)? or start fresh (No)?"}
      });

      dialogRef.afterClosed().subscribe(result => {
        if(result=="yes"){

          data["accountid"] = this.data.account["id"];
          data["name"] = this.sName;
          data["action"] = "copylast";
          this.versionService.updateVersion(data);

          this.showSave = false;
          this.showCancel = false;
          this.showDelete = true;
          this.showAdd = true;

        } else if(result=="no")  {

          data["accountid"] = this.data.account["id"]
          data["name"] = this.sName;
          this.versionService.updateVersion(data);

        } else {
          this.nameField.nativeElement.focus();
          setTimeout(() => {
            this.nameField.nativeElement.setSelectionRange(0, this.sName.length);
          },50)

          this.showSave = true;
          this.showCancel = true;
          this.showDelete = false;
          this.showAdd = false;

          return;
        }
      });
    }

    this.showSave = false;
    this.showCancel = false;
    this.showDelete = true;
    this.showAdd = true;
  }

  delete():void {
    if(this.sVersionSelected=='0') return;

    const dialogRef = this.dialog.open(OKCancelDialog, {
      width: '350px',
      data: {title:"Confirm", text: "Are you sure you want to delete this version?"}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result=="ok"){
        let data = {};
        let vdata = this.versionsData.filter(x => (x["id"] == this.sVersionSelected))
        if(vdata.length>0){
          data = this.deepCopy(vdata[0]);
        }
        this.versionService.deleteVersion(data);

        this.showSave = false;
        this.showCancel = false;
        this.showDelete = true;
        this.showAdd = true;
      }
    });
  }

  add(){

    this.sName = "New Version";
    this.nameField.nativeElement.focus();
    setTimeout(() => {
      this.nameField.nativeElement.setSelectionRange(0, this.sName.length);
    },50)

    this.sCreatedBy = "";
    this.sCreatedOn = "";

    this.sVersionBind = undefined;
    this.sVersionSelected = undefined;

        this.showSave = true;
        this.showCancel = true;
        this.showDelete = false;
        this.showAdd = false;

  }

  cancel(){
    if(this.sVersionSelected==undefined){
      // cancel on an add - select the top one
      let topone = this.versionsData[0].id
      this.sVersionBind  = [topone]
      this.selectionChange([topone])
    } else {
    // reload the original data
    this.sName = this.sOrginalName;
    }
  }

  close(){
    this.dialogRef.close({"action":"cancel"});
  }

  select(){
    this.dialogRef.close({"action":"select","versionid":this.sVersionSelected,"name":this.sName});
  }



  nameChange(ev){
    if(this.sVersionSelected=='0') return;

    if(ev.target.value != this.sOrginalName){
      this.showSave = true;
      this.showCancel = true;
    } else {
      this.showSave = false;
      this.showCancel = false;
    }

    // don't allow a blank save
    if(ev.target.value.trim()==""){
      this.showSave = false;
    }
  }

    // deep copy of Object
    private deepCopy(obj) {
      return Object.keys(obj).reduce((v, d) => Object.assign(v, {
        [d]: obj[d]== null ? null : (obj[d].constructor === Object) ? this.deepCopy(obj[d]) : obj[d]
      }), {});
    }

}



// TODO - put this as a seperate component - bound to need it
@Component({
  selector: 'okcanceldialog',
  styleUrls: ['./versions.component.scss'],
  template: `<h3 class="mat-dialog-title aip-dialog-title">{{data.title}}</h3>
  <div class="mat-dialog-content aip-dialog-text">
    {{data.text}}
</div>
  <div class="mat-dialog-actions" align="end">
    <button class="mat-focus-indicator aip-button mat-raised-button mat-button-base mat-primary" (click)="ok()">OK</button>
    <button class="mat-focus-indicator aip-button-alt mat-raised-button mat-button-base" (click)="cancel()" cdkFocusInitial>Cancel</button>
</div>
    `
})
export class OKCancelDialog {

  constructor(
    public dialogRef: MatDialogRef<OKCancelDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ok(): void {
      this.dialogRef.close("ok");
    }

  cancel(): void {
    this.dialogRef.close("cancel");
  }

}

@Component({
  selector: 'yesnodialog',
  styleUrls: ['./versions.component.scss'],
  template: `<h3 class="mat-dialog-title aip-dialog-title">{{data.title}}</h3>
  <div class="mat-dialog-content aip-dialog-text">
    {{data.text}}
</div>
  <div class="mat-dialog-actions" align="end">
    <button class="mat-focus-indicator aip-button mat-raised-button mat-button-base" (click)="yes()">Yes</button>
    <button class="mat-focus-indicator aip-button mat-raised-button mat-button-base" (click)="no()">No</button>
    <button class="mat-focus-indicator aip-button-alt mat-raised-button mat-button-base" (click)="cancel()" cdkFocusInitial>Cancel</button>
</div>
    `
})
export class YesNoDialog {

  constructor(
    public dialogRef: MatDialogRef<OKCancelDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    yes(): void {
      this.dialogRef.close("yes");
    }
    no(): void {
      this.dialogRef.close("no");
    }
  cancel(): void {
    this.dialogRef.close("cancel");
  }

}

